<template>
	<!-- <div id="indexpage"  v-title data-title="首页"> 
		<headerbar msg="chanyednao" :curindex="false"> </headerbar> 
		<div class="por" style="background-color: #19213c;height: auto;"> 
			<indexswiperA v-if="swipernum == 1"></indexswiperA>
		 
			<indexswiperB v-if="swipernum == 2"></indexswiperB>
			
			<indexswiperC v-if="swipernum == 3"></indexswiperC> 
 
			<indexswiperD v-if="swipernum == 4"></indexswiperD>
			 
			<div class="indextoggle">
				<span v-for="(item,index) in indexpagef" @click="swipernum=(index+1)" :class="swipernum == (index+1) ?'current':''">{{item}}</span>
			</div>
		</div> 
		<footerbar :indexfooter="false"></footerbar>
	</div> -->
</template>
<script>
	export default {
		name: 'index',
		data() {
			return { 
				title: "首页",
				usernotionlistsave:[],
				islogin: false,
				swipernum:1,
				userdata:{},
			 public_tooltip: { trigger: 'axis', backgroundColor: 'rgba(255,255,255,0.9)', borderColor: '#ddd', borderWidth: '1', textStyle: { color: '#000', fontSize: 14, } },
			 colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60","#ff0","#f87f8f"],  
				indexpagef:['汇总','龙头企业','创新企业','投资机构'],
			}
		},
		created() {
			// this.bus.$emit('loading', true);
			var _this=this; 
			this.userdata = this.getuseriformation();
		},
		mounted() {
			//echart只能放在稍后的地方 
		},
		methods: {
			routerpage(path){
				let routeUrl = this.$router.resolve({path: path});
				window.open(routeUrl.href, '_blank'); 
			},  
			
			//methods尾部
		}
	}
</script>

<style scoped="scoped">
.indextoggle{
	overflow: hidden;color: #fff;text-align: center;height: 64px;cursor: pointer;margin-top: 30px;padding-bottom: 10px;padding-top:3px;
}
.indextoggle span{
	margin-right: 10px;font-size: 14px;padding:4px 10px;border: 1px solid #eee;
}
.indextoggle span.current{
	background: #ffbb1c;
} 
</style>
